<template>
    <div
        v-bind="$attrs"
        :class="{
            'overflow-hidden': transition,
        }"
        :style="{
            height: animation == 'in' ? height + 'px' : '0px',
            transition: !transition ? 'height 0s' : 'height 0.' + duration + 's',
        }"
    >
        <div ref="content" :class="contentClass">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    inheritAttrs: false,

    props: {
        visable: { type: Boolean, default: false },
        duration: { type: Number, default: 35 },
        contentClass: { type: [String, Object, Array], default: '' },
    },

    mounted() {
        this.setLoadHeight()
    },

    data() {
        return {
            height: 0,
            animation: null,
            transition: true,
            interval: null,
        }
    },

    methods: {
        toggleVisibility() {
            clearInterval(this.interval)
            const isInitialLoad = this.animation === null
            this.animation = this.visable == true ? 'in' : 'out'

            if (this.visable) {
                if (isInitialLoad) {
                    this.transition = false
                } else {
                    this.interval = setTimeout(() => {
                        this.transition = false
                    }, this.duration * 10)
                }
            } else {
                this.transition = true
            }
        },

        setLoadHeight() {
            let h = this.$refs?.content?.clientHeight

            if (h != undefined && h != 0) {
                this.height = h

                new ResizeObserver(() => {
                    this.height = this.$refs != undefined && this.$refs.content != undefined ? this.$refs.content.clientHeight : 0
                }).observe(this.$refs.content)

                // console.log('setLoadHeight', h)
            } else {
                setTimeout(() => {
                    this.setLoadHeight()
                }, 100)
            }
        },
    },

    watch: {
        visable: {
            handler() {
                this.toggleVisibility()
            },
            immediate: true,
        },
    },
}
</script>
